import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Permissions } from '../approval/types'
import { authMode } from './types'

export interface CascadeAccessCodeData {
  /** 接入码 */
  access_code?: string
}
export interface CascadeApplyParams {
  /** 接入码 */
  access_code: string
  /** 服务器地址 */
  server_host: string
  /** 服务器端口 */
  server_port: number | unknown
  /** 子级服务器地址 */
  child_server_host: string
  /** 子级服务器端口 */
  child_server_port: number | unknown
  config?: []
}
export interface CascadeApplyData {
  /** 申请ID */
  apply_id?: string
}

export interface CascadeUnbindParams {
  /** 级联id */
  cascade_relation_id?: string
}
export interface InfoTreeData {

}
export interface CascadeAppliesParams {
  /** 每页数量 */
  limit?: number
  /** 页码 */
  page?: number
  /** 申请状态筛选 1=待审核， 2=审核通过， 3=审核拒绝 */
  status?: string | number
  //开始时间
  start_time: number,
  // 结束时间
  end_time: number,
  // 前端参数
  date: [],
  // ip,名称
  keyword: string
}
export interface AuthServiceInfos {
  /** 服务名 */
  name: string
  /** 数量 */
  count: number
}
export interface TeamTerminal {
 /** 上级团队ID */
  parent_team_id: string
  /** 团队ID */
  team_id: string
  /** 团队名称 */
  name: string
  /** 权限信息 */
  auth_info?: string
  // permissions
  permissions: Permissions[]
  /** 授权服务信息 */
  auth_service_infos?: AuthServiceInfos[]
  /** 授权模式：1-独立授权，2-级联授权 */
  auth_type?: number
  /** 下级 地址 */
  child_ip_addr?: string
  /** ip 地址 */
  ip_addr?: string
  /** linux终端数 */
  linux_num?: number
  /** mac 终端数 */
  mac_num?: number
  /** windows终端数 */
  windows_num?: number
  /** windows server终端数 */
  windows_server_num?: number
  cascade_relation_id: string
}
export interface Apply {
  /** 申请ID */
  id: string
  /** 下级团队ID */
  child_team_id: string
  /** 上级团队ID */
  parent_team_id: string
  /** 团队名称 */
  team_name: string
  /** 接入码 */
  access_code: string
  /** 服务器地址 */
  server_host: string
  /** 服务器端口 */
  server_port: number
  /** 服务器地址 */
  child_server_host: string
  /** 服务器端口 */
  child_server_port: number
  cascade_relation_id: string
  /** 申请状态 1=待审核， 2=审核通过， 3=审核拒绝 */
  status: string
  /** 申请时间 */
  apply_time: string
  /** 审批时间 */
  approve_time: string
  /** 审批原因 */
  approve_reason: string
  /** 创建时间 */
  create_time: string
  /** 更新时间 */
  update_time: string
  child_ip_addr: string
}
export interface AuthListData {
  /** 订单id */
  order_id: string
  /** 套餐名称 */
  name: string
  /** 剩余可授权台数|已授权数 */
  auth_count: number
  /** 剩余可用时长（过期天数） */
  expires_days: number
  /** 下级授权台数 */
  children_auth_count: number
}

export interface ResponseData {
  data?: AuthListData[]
}
export interface AuthParams {
  /** 授权模式：1-独立授权 2-级联 */
  permission_type?: authMode
   /** 团队id */
  team_id?: string
}
export interface AuthSubmitParams {
  /** 授权的下级团队id */
  children_team_id?: string
  data?: AuthInfoData[]
  permission_type?: number
}
export interface AuthInfoData {
  /** 订单id */
  order_id: string
  /** 子级可用授权台数 */
  children_auth_count: number
}

@Injectable()
export class CascadeService {
  constructor(private http: Http) {
  }
  // 生成接入码
  getCascadeAccessCode() {
    return this.http.post<CascadeAccessCodeData>('/cascade/get_access_code', {})
  }
  // 刷新接入码
  getCascadeRefreshAccessCode() {
    return this.http.post<CascadeAccessCodeData>('/cascade/refresh_access_code', {})
  }
  // 申请连接
  getCascadeApply(data: Apply) {
    return this.http.post<CascadeApplyData>(data.id ? '/cascade/update' : '/cascade/apply', data)
  }
  //解除级联关系
  getCascadeUnbind(data: CascadeUnbindParams) {
    return this.http.post<void>('/cascade/unbind', data)
  }
  //撤回审批
  getCascadeRevokeApply(data: CascadeApplyData) {
    return this.http.post<void>('/cascade/revoke_apply', data)
  }
  //获取当前上级申请信息
  getCascadeSuperiorApply() {
    return this.http.post<Apply>('/cascade/superior_applies', {})
  }
  //级联结构列表
  getTerminalInfoTeamTerminalList() {
    return this.http.post<TeamTerminal[]>('/cascade/team_terminal_list', {})
  }
    //级联列表-获取授权管理
  getCascadeTerminalAuthorize(data: AuthParams) {
    return this.http.post<ResponseData>('/cascade/terminal_authorize', data)
  }
  //级联列表-授权管理-保存
  getCascadeAuthorizeSave(data: AuthSubmitParams) {
    return this.http.post<void>('/cascade/authorize_save', data)
  }
}
